module.exports = __webpack_public_path__ + "static/img/waiting.b508fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/waiting.png
// module id = 673
// module chunks = 1